import { render, staticRenderFns } from "./reviewFiles.vue?vue&type=template&id=a224fa9a&scoped=true&"
import script from "./reviewFiles.vue?vue&type=script&lang=js&"
export * from "./reviewFiles.vue?vue&type=script&lang=js&"
import style0 from "./reviewFiles.vue?vue&type=style&index=0&id=a224fa9a&lang=less&scoped=true&"
import style1 from "./reviewFiles.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a224fa9a",
  null
  
)

export default component.exports